var Config = {

	imgUrl:function() {
		if (window.location.href.includes('localhost'))
			return '';
		else if (window.location.href.includes('-dev'))
			return '//codi-studios-dev.netlify.app';
		else
			return 'http://www.codistudios.com';
	},
};

module.exports = Config;



// WEBPACK FOOTER //
// ./ui_src/app/utils/Config.jsx